<!-- @format -->

<script setup></script>
<template>
  <div class="cls_box">
    <slot></slot>
  </div>
</template>
<style scoped>
.cls_box {
  position: relative;
}
.cls_box * {
  position: absolute;
  left: 0;
  top: 0;
}
</style>
